import { bchIcon, bitcoinIcon, dogecoinIcon, ethereumIcon, litecoinIcon } from ':fat/assets';
import { Network } from ':fat/core/networks';

export function getCurrencyIcon(network: Network): string {
  const assetIcons: Record<Network, string> = {
    btc: bitcoinIcon,
    ltc: litecoinIcon,
    doge: dogecoinIcon,
    bch: bchIcon,
    eth: ethereumIcon,
  };

  return assetIcons[network] ?? '';
}
